module.exports = __webpack_public_path__ + "img/icon_blue-big_ticket.0529b6a5.svg";